import * as React from "react";
import "twin.macro";

export const SectionHeading = (props) => (
  <h2 tw="text-4xl sm:text-5xl font-black tracking-wide" {...props} />
)